import Vue from "vue";
//模块功能：港口服务与大屏
export default Vue.extend({
    name: "port-service-screen",
    data: function () {
        return {};
    },
    mounted: function () {
    },
    methods: {},
    computed: {
        contents: function () {
            return this.$t('productsdetail.portservice');
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/product/port-service-screen.vue
// module id = null
// module chunks = 